import VueRouter from "vue-router";
import routes from "./config";
import Vue from "vue";

Vue.use(VueRouter);
const router = new VueRouter({
  routes,
  mode: "history",
});

router.afterEach(() => {
  window.scroll(0, 0);
});

export default router;

export function getMenus(configs) {
  if (!configs || configs.length === 0) {
    return [];
  }
  let menus = [];
  for (const config of configs) {
    if (config.meta && config.meta.show) {
      menus.push(config);
      //子节点
      config.subMenus = getMenus(config.children);
    } else {
      menus = menus.concat(getMenus(config.children));
    }
  }
  menus.sort((a, b) => a.meta.menuOrder - b.meta.menuOrder);
  return menus;
}

export function getBreads(matches) {
  const breads = [];
  for (const match of matches) {
    if (match.meta.menuName) {
      breads.push(match);
    }
  }
  return breads;
}
